import * as React from "react";
import Calendar from "react-calendar";
import './FormMobileCalendar.css'
import FormButton from "../FormButton/FormButton";
import {observer} from "mobx-react";
import {observe} from "mobx";

interface IProps {
    onSelect: (date: Date) => void;
    store: any;
}

interface ILocalState {
    isOpen: boolean;
    selectedDate: Date;
    calendarButton: string;
}
@observer
export default class FormMobileCalendar extends React.Component<
    IProps, ILocalState & Partial<any>
    > {

    public state = {
        isOpen: false,
        selectedDate: new Date(),
        calendarButton: "disabled"
    };

    public disposer = observe(this.props.store, "_isModalOpen", change => {
        const newState = this.state;
        newState.isOpen = this.props.store._isModalOpen;
        this.setState(newState);
    });

    public change = (date: any) => {
        const newState = this.state;
        newState.selectedDate = date;
        newState.calendarButton = "blue";
        this.setState(newState);
    };

    public toggleCalendar = () => {
        const newState = this.state;
        newState.isOpen = !this.state.isOpen;
        newState.selectedDate = this.state.selectedDate === new Date()? new Date() : this.state.selectedDate;
        newState.calendarButton = "disabled";
        this.setState(newState);
        this.props.store.updateModalStatus(this.state.isOpen);

    };

    public getButtonText = () => {
        return this.state.selectedDate.toLocaleDateString()
    };

    public isDateDisabled = (props: any ) => {
        return props.date < new Date();
    };


    public selectDate = () => {
        const {store, onSelect} = this.props;
        const newState = this.state;
        newState.isOpen = !this.state.isOpen;
        this.setState(newState);
        store.updateModalStatus(false);
        onSelect(this.state.selectedDate);
    };

    public getButtonClasses = () => {
      return this.state.calendarButton
    };

    public containerClick = (e: any) => {
        if(e.target === e.currentTarget) {
            this.toggleCalendar();
        }
    };

    public getCalendarValue = () => {
        if(this.state.selectedDate === new Date()) {
            return undefined
        }
        return this.state.selectedDate;
    }

    public renderCalendar = () => {
        return this.state.isOpen && this.props.store.isModalOpen ? <div className="mobile-calendar-container" onClick={this.containerClick}>
            <div className="calendar-container">
                <Calendar
                    value={this.getCalendarValue()}
                    className="form-mobile-calendar"
                    showNeighboringMonth={true}
                    prev2Label={null}
                    next2Label={null}
                    tileDisabled={this.isDateDisabled}
                    onChange={this.change}
                />
                <div className="btn-container">
                    <FormButton btnText={"Select date"} click={this.selectDate} classes={this.getButtonClasses()} />
                </div>
            </div>
        </div> : <FormButton classes={"calendar"} click={this.toggleCalendar} btnText={this.getButtonText()} icon={'calendar'}/>
    };

    public render() {
        {return this.renderCalendar()}
    }
}


// WEBPACK FOOTER //
// ./src/components/FormMobileCalendar/FormMobileCalendar.tsx